import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import MapView from './MapView';
import RouteSharedBanner from './RouteSharedBanner';

// The map is mounted once here, in the layout element of the route tree, and never
// unmounts as the URL changes — react-router only swaps the child <Outlet/>. MapLibre is
// expensive to instantiate and is the heart of the app, so navigation must not tear it
// down. Ride list/detail render as overlays above the live map via the Outlet; on the
// index route the Outlet is empty and the map chrome (bottom bar etc.) shows through.
// The shared-route banner lives here (not in MapView) so a push from the channel is
// visible on every screen. It renders *after* the Outlet and carries a higher z-index than
// the page/editor/review overlays (all z-30), so it is actually on top of them — otherwise
// a route pushed to the channel while the user is on the Rides list or a detail page would
// be painted over and never seen.
const MapShell: FC = () => (
  <>
    <MapView />
    <Outlet />
    <RouteSharedBanner />
  </>
);

export default MapShell;
